<!--
  navItem „Beträge“ — berechneter Betrag, Overwrite sowie Rücklage- und Zielbeträge.
  Die sechs vom Lauf gerechneten Felder tragen pro Feld die Tatsachenaussage „noch nicht
  berechnet“; die Erklärung steht einmal am Blockkopf. Der Overwrite-Block bleibt bewusst ohne
  Hinweis — er wird von Hand gesetzt, ein leerer Overwrite ist eine echte Aussage.
-->
<div class="cp-provision-contract-agent-amounts">

    <cp-provision-object-data
            objectType="cp.ProvisionContractAgent"
            [objectId]="provisionContractAgentId"
            widgetAlias="cp.contractAgent.amounts"
            widgetTitle="Beträge"
            [fields]="fields"
            [pendingFields]="pendingFields"
            [columns]="columns"
            emptyText="Kein Provisionssatz ausgewählt.">
    </cp-provision-object-data>

</div>
